module.exports = { id: "reflector", url: "/build/app/img/symbols.svg#reflector", viewBox: "", toString: function() { return this.url; } };